<template>
    <div class="">
        <h5>{{ $t("filters.filter_by") }}</h5>
        
        <div class="uk-grid" v-for="(filter, filterIndex) in filters" :key="filterIndex" uk-toggle="cls: uk-grid-xsmall; mode: media; media: (max-width: 560px)">
            <div class="uk-visible@m uk-margin-small-bottom">
                <div>{{ getFilterLabel(filterIndex) }}</div>
                <!-- Show only first 10 filters or all if showMoreFilters[filterIndex] === true -->
                <dr-checkbox
                    v-for="(filterItem, itemIndex) in getVisibleItems(filter.items, filterIndex)"
                    :key="itemIndex"
                    :filterItem="filterItem"
                    :filterItemKey="filterItem.slug ? filterItem.slug.replace(/-/g, '_') : (filterItem.label | array_key)"
                    :itemIndex="itemIndex"
                    :filterIndex="filterIndex"
                    :filterId="filter.id"
                />
                
                <!-- "Show more" / "Show less" button -->
                <div v-if="filter.items.length > 10" class="">
                    <button class="uk-button uk-button-link uk-link-orange" @click="toggleShowMore(filterIndex)">
                        {{ showMoreFilters[filterIndex] ? $t('filters.show_less') : $t('filters.show_more') }}
                    </button>
                </div>
            </div>
            <div class="uk-hidden@m uk-width-1-1">
                <dr-dropdown-checkboxes
                    :activeFilters="activeFilters"
                    :filterId="filter.id"
                    :filterIndex="filterIndex">
                    <dr-checkbox
                        v-for="(filterItem, itemIndex) in filter.items"
                        :key="itemIndex"
                        :filterItem="filterItem"
                        :filterItemKey="filterItem.slug ? filterItem.slug.replace(/-/g, '_') : (filterItem.label | array_key)"
                        :itemIndex="itemIndex"
                        :filterIndex="filterIndex"
                        :filterId="filter.id"
                    />
                </dr-dropdown-checkboxes>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from "./Checkbox.vue";
    import DropdownCheckboxes from "./Dropdown-checkboxes.vue";
    import { mapGetters } from "vuex";

    export default {
        name: "dr-checkbox-group",
        components: {
            'dr-checkbox': Checkbox,
            'dr-dropdown-checkboxes': DropdownCheckboxes
        },
        data() {
            return {
                showMoreFilters: {} // Object to store "Show more" state for each filter category
            };
        },
        mounted() {
            // Check URL parameters to set initial showMoreFilters state
            const query = this.$route.query;
            for (let filterCategory in this.filters) {
                if (query[filterCategory]) {
                    // If URL has parameters for this filter category,
                    // set showMoreFilters[filterCategory] = true
                    this.$set(this.showMoreFilters, filterCategory, true);
                }
            }
        },
        computed: {
            ...mapGetters([
                'filters',
                'activeFilters'
            ])
        },
        methods: {
            getFilterLabel(filterIndex) {
                // Try to get translation for this specific filter
                const translation = this.$t('filters.' + filterIndex);
                
                // If translation is the same as the key, it means it's not found
                if (translation === 'filters.' + filterIndex) {
                    // Fallback to a more readable format
                    return filterIndex.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                }
                
                return translation;
            },
            toggleShowMore(filterIndex) {
                // Toggle "Show more" state for the specified filter category
                this.$set(this.showMoreFilters, filterIndex, !this.showMoreFilters[filterIndex]);
            },
            getVisibleItems(items, filterIndex) {
                // If showMoreFilters[filterIndex] === true, show all items
                // Otherwise show only the first 10
                return this.showMoreFilters[filterIndex] ? items : items.slice(0, 10);
            }
        }
    }
</script>

<style lang="scss">
.uk-button-link.uk-link-orange {
    color: #ff5c35;
    text-decoration: none;
    
    &:hover {
        color: #e64a24;
        text-decoration: underline;
    }
}
</style>
